import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, FormInput } from 'shards-react';

const BulkReparseJobSearch = ({ onSearch }) => {
  const [searchId, setSearchId] = useState('');

  const handleSearch = () => {
    const id = searchId.trim();
    if (id) onSearch(id);
  };

  return (
    <>
      {/* TODO: Revisar si este buscador sigue siendo necesario cuando se incorpore el listado de los últimos jobs. */}
      <Row className="mt-4">
        <Col lg="6" sm="12" xs="12">
          <FormInput
            id="bulk-reparse-search-id"
            onChange={(e) => setSearchId(e.target.value)}
            placeholder="Buscar tarea por ID"
            type="text"
            value={searchId}
          />
        </Col>
        <Col lg="2" sm="4" xs="12">
          <Button disabled={searchId.trim() === ''} onClick={handleSearch} outline>
            Buscar
          </Button>
        </Col>
      </Row>
    </>
  );
};

BulkReparseJobSearch.propTypes = {
  onSearch: PropTypes.func.isRequired
};

export default BulkReparseJobSearch;
